export const getInvalidConfiguredIds = (configuredIds, records) => {
  const validIds = new Set(records.map(record => Number(record.id)));
  return configuredIds.filter(id => !validIds.has(Number(id)));
};

export const isValidDelayedAssignmentWait = (waitMinutes, minimum, maximum) => {
  const numericWait = Number(waitMinutes);
  return (
    Number.isInteger(numericWait) &&
    numericWait >= minimum &&
    numericWait <= maximum
  );
};

export const usesAutomationBlockingLabel = (settings, labelIds) =>
  !!settings.agent_initiated_conversation_enabled &&
  labelIds.some(
    id => Number(id) === Number(settings.agent_initiated_conversation_label_id)
  );
